/**
 * @name Performance
 *
 * @description Utilities for measuring & reporting performance stats
 * @author Jesse Weed <jeweed@deloitte.com>
 * @class
 *
 * @example
 * const performance = new Performance();
 *
 * // START TIMER
 * performance.start();
 *
 * // STOP
 * performance.stop();
 *
 * // SNAPSHOT OF CURRENT TIME
 * performance.snapshot();
 */

class Performance {
  constructor() {
    this.endTime = null;
    this.startTime = null;
    this.now = require("performance-now");
  }

  /**
    Start timing current process and returns start time

    @example
    performance.start();

  */
  start() {
    this.startTime = this.snapshot();
    return this.startTime;
  }

  /**
    Returns the start, end & total processing time.

    * @example
    * performance.stop();

  */
  stop() {
    this.endTime = this.snapshot();

    return {
      end: this.endTime,
      start: this.startTime,
      loadTime: this.timer({
        endTime: this.endTime,
        startTime: this.startTime,
      }),
    };
  }

  /**
    Takes a snapshot of current state and returns current time

    * @example
    * performance.stop();

  */
  snapshot() {
    return this.now();
  }

  /**
    Returns diffenence between two times in ms or sec
  */
  timer(time) {
    const ms = time.endTime - time.startTime;

    const sec = Math.round(ms / 1000);

    if (ms < 1000) {
      return `${Math.round(ms)}ms`;
    }
    return `${sec}s`;
  }
}

export default Performance;
